<template>
  <div class="confirm-registration">
        <div class="container">
                <div class="row">
                        <div class="col-md-12 text-center" style="padding: 100px" v-html="status" />
                </div>
        </div>
  </div>
</template>

<script>
import API from "../../services/api.js";
import { mapMutations } from "vuex";
const api = new API();

export default {
  data() {
    return {
        status: `<h3>Confirming account</h3><h5>Please wait...</h5>`
    }
  },
  methods: {
    confirmAccount() {
        api.confirmAccount(this.$route.params.code).then(response => {
                if(response.data.success) {
                        //Confirmed
                        this.status = `<h5>Dear ` + response.data.data.name + `, thank you for verifying your email address.</h5><p>Please visit the Mobile App or the <a href='http://staging.nutrivitas.com/#/'>Web App</a> and login to start using Nutrivitas</p>`
                } else {
                        //Unconfirmed
                        this.status = `<h4>The verification code provided is invalid.</h4>`
                }
        });
    }
  },
  mounted() {
    this.$store.commit("resetStore");
    this.confirmAccount();
  }
};

function pad(num, size) {
        var s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Login/ConfirmRegistration.vue